import { CALL_API } from '../middleware/api';

export const FETCHING_MAILING_LOGS = 'FETCHING_MAILING_LOGS';
export const FETCHING_MAILING_LOGS_SUCCESS = 'FETCHING_MAILING_LOGS_SUCCESS';
export const FETCHING_MAILING_LOGS_FAILURE = 'FETCHING_MAILING_LOGS_FAILURE';
export const UPDATE_MAILING_LOGS = 'UPDATE_MAILING_LOGS';

export function getMailingLogs({ batchId, page = 1, sortBy = null }) {
  const query = {
    page,
    limit: 100,
  };

  if (sortBy) {
    query.sort = sortBy;
  }

  return {
    [CALL_API]: {
      method: 'get',
      path: `/api/v1/batch/${batchId}/mailing_logs`,
      query,
      startType: FETCHING_MAILING_LOGS,
      successType: FETCHING_MAILING_LOGS_SUCCESS,
      errorType: FETCHING_MAILING_LOGS_FAILURE,
    },
  };
}

export function updateMailingLogs({ filterName, filterData }) {
  return {
    type: UPDATE_MAILING_LOGS,
    filterName,
    filterData,
  };
}
